import React from "react";

interface LogoProps {
  size?: number;
}

export function Logo({ size = 32 }: LogoProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
    >
      <rect width="32" height="32" rx="8" fill="var(--accent)" />
      <path
        d="M8 16h4l3-6 5 12 3-6h4"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
